import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import { Wrapper } from '../styles';

export const Points = styled.td`
  position: relative;

  &:first-child {
    & > div {
      &:first-child {
        padding: 1.5rem 0 0;

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          margin: 0 1rem 0 0;
          padding: 1.5rem 0;
        }
      }

      &.product-page-points-column {
        &:first-child {
          padding: 1.5rem 0 0;
          margin: 0 auto;

          @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
            padding: 2.5rem 0 0;
          }
        }
      }

      &.single-table {
        &:first-child {
          @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
            margin: 0 15%;
          }
        }
      }

      &.points-section {
        &:first-child {
          padding: 1.88rem 0;
          margin: 0 1rem 0 1rem;

          @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
            padding: 1.88rem 0;
            margin: 0 0 0 2rem;
          }
        }
      }
    }
  }

  &.optimum {
    background-color: transparent;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-color: ${themeGet('colors.chart-pink')};
    }
  }

  &.pc-mastercard {
    background-color: transparent;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-color: ${themeGet('colors.light-border-grey')};
    }
  }

  &.pc-money {
    background-color: transparent;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-color: ${themeGet('colors.velvet')};

      p,
      span {
        color: ${themeGet('colors.white')};
      }
    }
  }

  &.white {
    background-color: transparent;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-color: ${themeGet('colors.white')};
    }

    ${Wrapper}.single-table & {
      background-color: ${themeGet('colors.white')};
    }
  }

  ${Wrapper}.chart &, ${Wrapper}.pcma-chart &, ${Wrapper}.single-table & {
    text-align: center;
    padding: 0;
    height: auto;
    width: ${props => `calc(100% / (${props.columnCount} - 1))`};
    display: inline-block;
    vertical-align: middle;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: ${props => `calc(100% / ${props.columnCount})`};
      display: table-cell;
    }

    &:first-child {
      width: 100%;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        text-align: left;
        vertical-align: middle;
        width: ${props => `calc(100% / ${props.columnCount})`};
      }
    }

    &:before {
      content: '';
      border-top: 2px solid ${themeGet('colors.light-border-grey')};
      position: absolute;
      top: 0;
      width: calc(100% - 1rem);
      height: 2px;
      display: none;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        display: block;
      }
    }

    &:nth-child(1) {
      &:before {
        left: 0;
        display: block;
        width: 100%;

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          width: calc(100% - 1rem);
        }
      }
    }

    &:nth-child(2) {
      &:before {
        right: 0;
      }
    }

    &:nth-child(3) {
      &:before {
        left: 0;
        right: ${props => (props.columnCount < '2' ? 'inherit' : 0)};
        width: ${props =>
          props.columnCount < '2' ? 'calc(100% - 1rem)' : '100%'};
      }
    }

    &:nth-child(4) {
      &:before {
        left: ${props => (props.columnCount === '4' ? 'inherit' : 0)};
        width: ${props =>
          props.columnCount === '4' ? 'calc(100% - 1rem)' : '100%'};
      }
    }

    &:nth-child(5) {
      &:before {
        left: 0;
      }
    }

    &.optimum,
    &.pc-mastercard,
    &.pc-money {
      &:not(.v2) {
        &:before {
          border-top: 2px solid ${themeGet('colors.white')};
        }
      }
    }

    &.selectable-card,
    &.pcma-chart,
    &.single-table {
      width: 50%;
      vertical-align: middle;

      &.v2 {
        width: 100%;
      }

      &:first-child {
        width: 100%;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        width: ${props => `calc(100% / ${props.columnCount})`};
      }
    }

    &.selectable-card {
      &.is-not-active {
        display: none;
      }

      &:nth-child(3),
      &:nth-child(4) {
        &:before {
          left: 0;
          width: calc(100% - 1rem);
        }
      }
    }
    &.single-table {
      &:before {
        display: none;
      }
      &:first-child {
        width: ${props => `calc(100% / ${props.columnCount})`};
        border-right: 2px solid ${themeGet('colors.light-border-grey')};
      }
    }
    &.v2 {
      &:first-child {
        padding-top: 0;
        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          padding-left: 2rem;
        }

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          padding-left: 2.5rem;
        }

        @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
          padding-left: 4rem;
        }
        &:before {
          display: none;
        }
      }
    }
  }

  ${Wrapper}.row-layout-chart & {
    &:before {
      content: '';
      border-top: 2px solid ${themeGet('colors.light-border-grey')};
      position: absolute;
      top: 0;
      width: 100%;
      height: 2px;
      display: none;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        display: block;
      }
    }

    &:first-child {
      &:before {
        display: block;
      }
    }

    &.optimum,
    &.pc-mastercard,
    &.pc-money,
    &.white {
      background-color: transparent;
    }
  }

  ${Wrapper}.two-column & {
    width: 100%;
    display: inline-block;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 75%;
      display: table-cell;
    }

    &:first-child {
      width: 100%;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        width: 25%;
      }
    }
  }

  ${Wrapper}.row-layout-chart.two-column & {
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 70%;
    }

    &:first-child {
      width: 100%;
      vertical-align: middle;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        width: 30%;
      }
    }
  }

  ${Wrapper}.row-layout-chart.product-page-points-column & {
    width: 100%;
    display: block;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: calc(100% / 3);
      display: table-cell;
    }

    &:before {
      content: '';
      border-top: 2px solid ${themeGet('colors.light-border-grey')};
      position: absolute;
      top: 0;
      width: 100%;
      height: 2px;
      display: block;
    }
  }

  ${Wrapper}.selectable-card:not(.v2) &, ${Wrapper}.pcma-chart &, ${Wrapper}.single-table & {
    &:before {
      @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
        border-top: 2px solid ${themeGet('colors.white')};
      }

      &:nth-child(1) {
        @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
          &:before {
            border-top: 2px solid ${themeGet('colors.light-border-grey')};
            width: calc(100% - 2rem);
            left: 1rem;
          }
        }
      }
    }
  }
`;

export const ContentWrapper = styled.div`
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 1.5rem 0;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 2.5rem 0;
  }

  &.two-column {
    &.row-layout-chart {
      justify-content: center;
      text-align: center;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        justify-content: flex-start;
        text-align: left;
      }
    }
  }

  &.product-page-points-column {
    align-items: flex-end;
    min-height: auto;
    padding: 1.5rem 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      min-height: 8.625rem;
      padding: 1rem 0 2.5rem;
    }

    &:first-child {
      min-height: auto;
      align-items: center;
      margin: 0 auto;
      padding: 1.5rem 0 0;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        min-height: 5rem;
        padding: 2.5rem 0 0;
      }
    }
  }

  &.points-section {
    padding: 0 0.5rem 0 1rem;
    justify-content: normal;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding: 0 0 0 2rem;
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: flex-start;
  }

  &.product-page-points-column {
    margin: 0 auto;
    width: 50%;
    min-width: 7.5rem;
    justify-content: center;

    @media only screen and (max-width: 640px) {
      margin: 0;
    }
  }
`;

export const HeaderImage = styled(Image)`
  max-height: 2.5rem;

  ${ContentWrapper}.selectable-card:not(.v2) &, ${ContentWrapper}.pcma-chart &, ${ContentWrapper}.single-table & {
    width: 140px;
    height: 40px;
    background-color: white;
    border: 1px solid ${themeGet('colors.white')};
    border-radius: 100px;
    padding: 5px 20px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      border: none;
      background: transparent;
      padding: 0;
      border-radius: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 125px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: none;
  }
`;

export const ImagePoints = styled(Image)`
  width: auto;
  margin-bottom: 1rem;
  max-width: 2.25rem;
  height: 1.625rem;

  @media only screen and (min-width: 320px) {
    max-width: 1.875rem;
    height: 1.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 2.25rem;
    height: 1.625rem;
  }

  ${ContentWrapper}.row-layout-chart & {
    @media only screen and (max-width: 330px) {
      width: 1.5rem;
    }
  }

  ${ContentWrapper}.points-section & {
    width: 1.25rem;
    height: 1.25rem;
    margin-top: -0.5rem;
    margin-left: 0.25rem;
    margin-bottom: unset;
  }

  display: ${({ percentage }) => (percentage ? 'none' : 'block')};
`;

export const Heading = styled.div`
  width: 100%;

  p {
    font-size: 1.25rem;
    line-height: 1.25rem;
    font-weight: ${themeGet('fontWeights.medium')};

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.5rem;
      line-height: 2rem;
    }

    sup {
      ${({ lang }) =>
        lang === 'fr'
          ? css`
              font-size: 0.3rem;
              top: -0.4rem;

              @media only screen and (min-width: 340px) {
                font-size: 0.4rem;
              }

              @media only screen and (min-width: ${themeGet(
                  'breakpoints.sm',
                )}) {
                font-size: 0.5rem;
              }

              @media only screen and (min-width: ${themeGet(
                  'breakpoints.md',
                )}) {
                top: -0.5rem;
              }

              @media only screen and (min-width: ${themeGet(
                  'breakpoints.xlg',
                )}) {
                top: -0.8rem;
              }
            `
          : null}
    }
  }

  ${ContentWrapper}.selectable-card:not(.v2) &, ${ContentWrapper}.pcma-chart &, ${ContentWrapper}.single-table & {
    p {
      font-size: 1rem;
      line-height: 1.25rem;
      background-color: ${themeGet('colors.white')};
      border: 1px solid ${themeGet('colors.white')};
      border-radius: 100px;
      width: fit-content;
      padding: 10px;
      margin: auto;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        border: none;
        background-color: transparent;
        width: unset;
        padding: 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 1.125rem;
        line-height: 1.375rem;
      }
    }
  }

  span {
    font-size: 1.125rem;
    line-height: 1.375rem;

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.25rem;
      line-height: 1.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  ${ContentWrapper}.single-table & {
    p {
      font-weight: ${themeGet('fontWeights.normal')};
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      text-align: left;
    }
  }

  ${ContentWrapper}.v2 & {
    p {
      font-size: 1.25rem;
      font-weight: ${themeGet('fontWeights.normal')};
      line-height: 1.625rem;
    }
  }

  ${ContentWrapper}.points-section & {
    p {
      font-size: 1rem;
      font-weight: ${themeGet('fontWeights.normal')};
      line-height: 1.625rem;
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  &.product-page-points-column {
    justify-content: center;
  }

  ${ContentWrapper}.chart &, ${ContentWrapper}.pcma-chart &, ${ContentWrapper}.single-table & {
    justify-content: center;
    max-width: 6.25rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: none;
      width: 100%;
    }
  }

  ${ContentWrapper}.row-layout-chart & {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: none;
      width: 100%;
    }
  }

  .sr-spacing {
    font-size: 1rem;
    font-weight: 400;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  ${Points}.pcma-chart.pc-money & {
    color: ${themeGet('colors.white')};
  }

  ${ContentWrapper}.single-table & {
    color: ${themeGet('colors.main-text')};
  }
`;

export const PointValue = styled.span`
  font-size: 2.625rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 0.95;
  color: inherit;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 3.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    font-size: 4.5rem;
  }

  ${Body}.product-page-points-column & {
    font-size: 3.25rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 4rem;
    }
  }

  ${Body}.two-column & {
    font-size: 3.25rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 4rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 4.5rem;
    }
  }

  ${ContentWrapper}.chart &, ${ContentWrapper}.pcma-chart &, ${ContentWrapper}.single-table & {
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 2.8rem;
    }
  }

  ${Points}.points-section & {
    font-size: 2rem;
  }
`;

export const ColumnHeading = styled.div`
  width: 100%;
  text-align: left;

  &.product-page-points-column {
    display: flex;
    justify-content: center;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      text-align: center;
    }
  }

  ${ContentWrapper}.chart &, ${ContentWrapper}.pcma-chart &, ${ContentWrapper}.single-table & {
    text-align: center;
  }

  ${ContentWrapper}.selectable-card & {
    p {
      padding: 0 0.5rem;
    }
  }

  p {
    font-size: 0.8rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
    }
  }

  &.vendor-row {
    margin-top: 0.75rem;

    p {
      font-size: 1.125rem;
      font-weight: ${themeGet('fontWeights.medium')};
    }
  }

  ${ContentWrapper}.points-section & {
    p {
      font-size: 1rem;
    }
  }
`;

export const SmallCopy = styled.p`
  position: relative;
  font-size: 0.8rem;
  align-self: center;
  justify-content: center;
  display: block;
  margin-top: -0.65rem;
  color: inherit;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 1rem -1.25rem 0;
    right: 0.5rem;
    font-size: 0.8rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    right: -0.5rem;
    margin: 1.3rem 0 0 -2.5rem;
    font-size: 1rem;
  }

  sup {
    top: -0.5em;
  }

  ${ContentWrapper}.row-layout-chart & {
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      margin-top: 0.75rem;
      margin-left: -1.75rem;
    }
  }

  ${ContentWrapper}.v2 & {
    font-size: 0.875rem;
  }

  ${ContentWrapper}.points-section & {
    right: unset;
    margin: 0 0 0 0.25rem;
  }
`;

export const VendorSetContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  background-color: ${themeGet('colors.white')};
  border-radius: 15px;
  padding: 26px 18px;
  width: 80%;
  margin: 1.5rem auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    background-color: transparent;
    border-radius: 0px;
    padding: 0;
    margin: 0;
    margin-top: 1.5rem;
  }
`;

export const VendorImages = styled(Image)`
  max-height: 2rem;
  padding: 0.25rem;
  width: 50%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 110px;
    max-height: 2rem;
    width: 100%;
  }
`;
